import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { getAdminAIUsage } from '../utils/api';
import { Cpu } from 'lucide-react';

export default function AdminAIUsage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getAdminAIUsage()
      .then(({ data }) => setData(data))
      .catch((e) => setError(e.response?.data?.detail || 'Failed to load usage'));
  }, []);

  return (
    <Layout variant="light">
      <div className="max-w-6xl mx-auto px-6 py-8" data-testid="admin-ai-usage-page">
        <h1 className="text-4xl font-black text-white mb-2 flex items-center gap-3"><Cpu className="text-lime" size={32} /> AI Usage</h1>
        <p className="text-light-gray mb-6">AI actions consumed per customer, per cycle. Caps: Monthly {data?.caps?.monthly}, Yearly {data?.caps?.yearly}/mo, Founders {data?.caps?.founders}/mo, Trial {data?.caps?.none}/mo.</p>
        {error && <p className="text-orange" data-testid="admin-ai-usage-error">{error}</p>}
        {data && (
          <div className="card overflow-x-auto">
            {data.rows.length === 0 ? (
              <p className="text-muted text-sm py-6 text-center">No AI usage recorded yet.</p>
            ) : (
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-gray border-b border-divider">
                    <th className="pb-3 pr-4">Customer</th>
                    <th className="pb-3 pr-4">Plan</th>
                    <th className="pb-3 pr-4">Period</th>
                    <th className="pb-3 pr-4">Used</th>
                    <th className="pb-3 pr-4">Cap</th>
                    <th className="pb-3 pr-4">Resets</th>
                    <th className="pb-3">Top Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data.rows.map((r, i) => {
                    const pct = r.cap ? Math.min(r.used / r.cap, 1) : 0;
                    return (
                      <tr key={i} className={`border-b border-divider/50 ${r.current_period ? '' : 'opacity-50'}`} data-testid={`ai-usage-row-${r.email}`}>
                        <td className="py-3 pr-4 text-white font-semibold">{r.email}</td>
                        <td className="py-3 pr-4 text-light-gray">{r.plan_label}</td>
                        <td className="py-3 pr-4 text-muted text-xs">{r.period_key}{r.current_period ? ' (current)' : ''}</td>
                        <td className="py-3 pr-4">
                          <span className={`font-bold ${pct >= 1 ? 'text-orange' : pct >= 0.8 ? 'text-lime' : 'text-white'}`}>{r.used}</span>
                        </td>
                        <td className="py-3 pr-4 text-light-gray">{r.cap === null ? '∞' : r.cap}</td>
                        <td className="py-3 pr-4 text-muted text-xs">{r.resets_on ? new Date(r.resets_on).toLocaleDateString() : '—'}</td>
                        <td className="py-3 text-muted text-xs">
                          {Object.entries(r.actions || {}).sort((a, b) => b[1] - a[1]).slice(0, 3).map(([k, v]) => `${k}: ${v}`).join(' · ') || '—'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </Layout>
  );
}
